import { Button, Flex, Icon, Popover } from "orcs-design-system";
import React from "react";
import styled from "styled-components";

import { PropTypes } from "prop-types";
import PersonPropType from "src/custom-prop-types/person";

import usePersonContactDetailItems from "./usePersonContactDetailItems";

const StyledButton = styled(Button)`
  width: 28px;
  height: 28px;
`;

const Tooltip = styled(Popover)`
  .popoverText {
    background: black;
    color: white;
    border-radius: 5px;
    border-color: transparent;
    display: flex;
    justify-content: center;
    &:before {
      border-right-color: black;
    }
  }
`;

const PersonContactDetails = ({ person, tooltipDirection = "top" }) => {
  const { contactDetailItems, renderNotification } =
    usePersonContactDetailItems({ person });

  return (
    <>
      <Flex>
        <Flex direction="row" gap="s">
          {contactDetailItems.map((detail) => (
            <Tooltip
              direction={tooltipDirection}
              key={detail.ariaLabel}
              text={detail.ariaLabel}
              width="fit-content"
            >
              <StyledButton
                fullWidth
                disabled={detail.disabled}
                iconOnly
                p="s"
                ariaLabel={detail.ariaLabel}
                onClick={detail.onClick}
                variant="ghost"
              >
                <Icon icon={detail.icon} />
              </StyledButton>
            </Tooltip>
          ))}
        </Flex>
      </Flex>

      {renderNotification()}
    </>
  );
};

PersonContactDetails.propTypes = {
  person: PersonPropType,
  tooltipDirection: PropTypes.string,
};

export default PersonContactDetails;
